export default "__VITE_ASSET__vN0pGp6K__"